import Vue from 'vue';
import Vuex from 'vuex';
import * as apis from '@/apis/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {},
  state: {
    articles: [],
    articlePage: {
      current: 1,
      pageSize: 20,
      total: 0,
    },
    jobs: [],
    jobPage: {
      current: 1,
      pageSize: 20,
      total: 0,
    },
  },
  mutations: {
    setPagination(state, payload) {
      const { total, limit, offset, type } = payload;

      state[type] = {
        current: offset / limit + 1,
        pageSize: limit,
        total,
      };
    },
    saveList(state, payload) {
      state[payload.type] = payload.data;
    },
    removeItem(state, payload) {
      const { id, type } = payload;
      state[type] = state[type].filter(item => item.id !== id);
    },
  },
  actions: {
    delArticle({ commit }, id) {
      apis
        .delArticle(id)
        .then(() => {
          commit('removeItem', { id, type: 'articles' });
        })
        .catch(err => console.error('store#delArticle', err));
    },
    getArticles({ commit }, params) {
      apis
        .getArticles(params)
        .then(({ data, pagination }) => {
          if (data && pagination) {
            commit('saveList', { data, type: 'articles' });
            commit('setPagination', { ...pagination, type: 'articlePage' });
          }
        })
        .catch(err => console.error('store#getArticles', err));
    },

    delJob({ commit }, id) {
      apis
        .delJob(id)
        .then(() => {
          commit('removeItem', { id, type: 'jobs' });
        })
        .catch(err => console.error('store#delJob', err));
    },
    getJobs({ commit }, params) {
      apis
        .getJobList(params)
        .then(({ data, pagination }) => {
          commit('saveList', { data: data.jobs, type: 'jobs' });
          commit('setPagination', { ...pagination, type: 'jobPage' });
        })
        .catch(err => console.error('store#getJobs', err));
    },
  },
});
